import MainTabs from "./pyq-components/MainTabs";
import usePyqRedux from "./hooks/usePyqRedux";
import YearWiseData from "./ui-components/YearWiseData";
import TopicWiseData from "./ui-components/TopicWiseData";
import PyqChallengeData from "./ui-components/PyqChallengeData";

const PreviousQuestionPaper = () => {
  const { pyqSubCurrentTab } = usePyqRedux();
  return (
    <div>
      <MainTabs />
      {pyqSubCurrentTab?.index == 1 && <YearWiseData />}
      {pyqSubCurrentTab?.index == 2 && <TopicWiseData />}
      {pyqSubCurrentTab?.index == 3 && <PyqChallengeData />}
    </div>
  );
};

export default PreviousQuestionPaper;
